/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddCarrierNoteResponse
 */
export interface AddCarrierNoteResponse {
  /**
   *
   * @type {string}
   * @memberof AddCarrierNoteResponse
   */
  carrierNoteId: string;
}

/**
 * Check if a given object implements the AddCarrierNoteResponse interface.
 */
export function instanceOfAddCarrierNoteResponse(
  value: object,
): value is AddCarrierNoteResponse {
  if (!("carrierNoteId" in value) || value["carrierNoteId"] === undefined)
    return false;
  return true;
}

export function AddCarrierNoteResponseFromJSON(
  json: any,
): AddCarrierNoteResponse {
  return AddCarrierNoteResponseFromJSONTyped(json, false);
}

export function AddCarrierNoteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCarrierNoteResponse {
  if (json == null) {
    return json;
  }
  return {
    carrierNoteId: json["carrierNoteId"],
  };
}

export function AddCarrierNoteResponseToJSON(
  json: any,
): AddCarrierNoteResponse {
  return AddCarrierNoteResponseToJSONTyped(json, false);
}

export function AddCarrierNoteResponseToJSONTyped(
  value?: AddCarrierNoteResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierNoteId: value["carrierNoteId"],
  };
}
